<template>
  <div
    v-if="this.entry"
    id="the-dict-entry"
    class="dictionary-entry-container"
    @click.self="$emit('close-dict')"
  >
    <div class="dict-box">
      <div class="dict-content-container">
        <div class="close-button" @click="$emit('close-dict')">
          <CloseButtonImage />
        </div>
        <h1>{{ entry.dict_text }}</h1>
        <div class="dict-explanation" v-html="entry.dict_explanation"></div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButtonImage from "@/assets/CloseButton.svg";
export default {
  name: "TheDictEntry",
  components: { CloseButtonImage },
  props: {
    entry: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
};
</script>

<style lang="scss" scoped>
#the-dict-entry {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: space-around;
  align-items: center;
  z-index: 2;

  .dict-box {
    display: flex;
    box-shadow: 0px 0px 20px 0px #0000001f;

    .dict-content-container {
      background: #ffffff;
      width: 400px;
      padding: 80px 60px;
      position: relative;
      border: 1px solid $gray;

      .dict-explanation {
        max-height: 500px;
        overflow-y: auto;
        /deep/ strong {
          font-weight: bold;
        }

        /deep/ ul {
          list-style-type: disc;
          padding-left: 20px;
        }
      }

      .close-button {
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
      }

      h1 {
        color: $green;
        margin-bottom: 20px;
        font-size: 16px;
      }
      * {
        color: $gray;
      }
    }
  }
}
</style>
